import React from 'react';

import { Card, Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import { IAppointment } from 'src/types/model';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    maxWidth: 600,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 50,
  },
  greenCard: {
    backgroundColor: '#005959',
    padding: '24px 16px',
    flex: 1,
    marginBottom: 0,
    color: '#fff',
  },
  diagnosisBadge: {
    backgroundColor: '#007BFF',
    color: '#fff',
    padding: '6px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'Inter',
    textAlign: 'center',
    marginBottom: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
}));

interface EmptyQuoteProps {
  appointment?: IAppointment | null;
}

const EmptyQuote: React.FC<EmptyQuoteProps> = ({ appointment }) => {
  const classes = useStyles();

  const isSm = useMediaQuery('(max-width: 1229px)');

  return (
    <Card
      style={{
        minWidth: !isSm ? '364px' : '95%',
        maxWidth: !isSm ? '364px' : '95%',
        height: 'fit-content',
        background: '#fff',
        borderRadius: 8,
        marginRight: 'auto',
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.06)',
      }}
      elevation={0}
    >
      <div className={classes.greenCard}>
        {appointment?.attributes.appointment_type === 'diagnosis' &&
          !appointment?.attributes.member_job &&
          !appointment?.attributes.fleet_job && (
            <div className={classes.diagnosisBadge}>
              <CheckCircle style={{ fontSize: '14px' }} />
              Become a Goodhood member and this diagnosis is free.
            </div>
          )}
        <Typography
          variant="body2"
          style={{
            fontSize: isSm ? '0.5rem' : 'inherit',
            fontFamily: 'Inter',
            margin: !isSm ? 5 : 0,
            fontWeight: 550,
          }}
        >
          Calculating Your Quote
        </Typography>

        <Typography
          variant="body2"
          style={{
            alignSelf: 'flex-end',
            fontSize: '32px',
            fontFamily: 'Inter',
            borderRadius: '5px',
            padding: 4,
          }}
        >
          $0.00
        </Typography>
      </div>
    </Card>
  );
};

export default EmptyQuote;
